import { ColumnDef } from '@tanstack/react-table';

import { useEventProductSets } from '@/modules/events/api';
import { ProductSet } from '@/modules/events/types';

import { ProductSetRemoveButton } from '../components';

export const useProductSets = ({
  eventId,
  stationId,
  enabled,
}: {
  eventId: string;
  stationId: string;
  enabled: boolean;
}) => {
  const { productSets, isFetching, restTableProps } = useEventProductSets(
    eventId,
    stationId,
    enabled
  );

  const columns: ColumnDef<ProductSet>[] = [
    {
      size: 400,
      accessorKey: 'name',
      header: 'Name',
      cell: ({ row }) => (
        <span className="line-clamp-1">{row.original.name}</span>
      ),
    },
    {
      size: 200,
      id: 'productsCount',
      header: 'Products',
      cell: ({ row }) => row.original.products?.length ?? 0,
    },
    {
      size: 40,
      id: 'actions',
      header: 'Action',
      enableHiding: false,
      cell: ({ row }) => (
        <ProductSetRemoveButton
          eventId={eventId}
          stationId={stationId}
          productSetId={row.original.id}
          productSetName={row.original.name}
          onSuccess={() => restTableProps.refetch()}
        />
      ),
    },
  ];

  return {
    columns,
    productSets,
    isFetching,
    restTableProps,
  };
};
